var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "merchant-form" }, [
    _vm.currentStep === 1
      ? _c(
          "div",
          { staticClass: "form-step" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "el-form",
              {
                ref: "basicForm",
                attrs: {
                  model: _vm.localFormData,
                  rules: _vm.basicRules,
                  "label-width": "120px",
                  size: "small",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "归属公司", prop: "company" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择归属公司",
                                  filterable: "",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.localFormData.company,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.localFormData, "company", $$v)
                                  },
                                  expression: "localFormData.company",
                                },
                              },
                              _vm._l(_vm.companyOptions, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "供应商名称",
                              prop: "merchantName",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入供应商名称",
                                disabled: _vm.isDisabled,
                              },
                              model: {
                                value: _vm.localFormData.merchantName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localFormData,
                                    "merchantName",
                                    $$v
                                  )
                                },
                                expression: "localFormData.merchantName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "miniapp-customer-row",
                    attrs: { gutter: 20 },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "miniapp-customer-item",
                            attrs: {
                              label: "关联小程序客户",
                              prop: "relatedCustomerType",
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { size: "small" },
                                on: { change: _vm.onRelatedCustomerTypeChange },
                                model: {
                                  value: _vm.localFormData.relatedCustomerType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.localFormData,
                                      "relatedCustomerType",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "localFormData.relatedCustomerType",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("全部"),
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: 0 } }, [
                                  _vm._v("部分"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.localFormData.relatedCustomerType === 0
                          ? _c(
                              "el-form-item",
                              {
                                staticClass: "miniapp-customer-select",
                                attrs: { label: " ", prop: "customerIds" },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass:
                                      "miniapp-customer-select__input",
                                    attrs: {
                                      placeholder: "请选择关联小程序",
                                      multiple: "",
                                      filterable: "",
                                      remote: "",
                                      clearable: "",
                                      "remote-method":
                                        _vm.searchCustomerOptions,
                                      loading: _vm.customerLoading,
                                    },
                                    model: {
                                      value: _vm.localFormData.customerIds,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.localFormData,
                                          "customerIds",
                                          $$v
                                        )
                                      },
                                      expression: "localFormData.customerIds",
                                    },
                                  },
                                  _vm._l(_vm.customerOptions, function (item) {
                                    return _c("el-option", {
                                      key: item.customerId,
                                      attrs: {
                                        label: item.appName,
                                        value: item.customerId,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "登录账号", prop: "loginAccount" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入登录账号",
                                autocomplete: "new-password",
                                readonly: false,
                              },
                              model: {
                                value: _vm.localFormData.loginAccount,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localFormData,
                                    "loginAccount",
                                    $$v
                                  )
                                },
                                expression: "localFormData.loginAccount",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "登录密码", prop: "loginPassword" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入登录密码",
                                type: "password",
                                "show-password": "",
                                autocomplete: "new-password",
                                readonly: false,
                              },
                              model: {
                                value: _vm.localFormData.loginPassword,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localFormData,
                                    "loginPassword",
                                    $$v
                                  )
                                },
                                expression: "localFormData.loginPassword",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "合作状态",
                              prop: "cooperationStatus",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择合作状态",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.localFormData.cooperationStatus,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.localFormData,
                                      "cooperationStatus",
                                      $$v
                                    )
                                  },
                                  expression: "localFormData.cooperationStatus",
                                },
                              },
                              _vm._l(
                                _vm.cooperationStatusOptions,
                                function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "开票方式", prop: "invoiceMethod" },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择开票方式",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.localFormData.invoiceMethod,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.localFormData,
                                      "invoiceMethod",
                                      $$v
                                    )
                                  },
                                  expression: "localFormData.invoiceMethod",
                                },
                              },
                              _vm._l(_vm.invoiceMethodOptions, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "维护人", prop: "maintainer" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择维护人",
                                  filterable: "",
                                  "filter-method": _vm.handleMaintainerSearch,
                                  clearable: "",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.localFormData.maintainer,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.localFormData,
                                      "maintainer",
                                      $$v
                                    )
                                  },
                                  expression: "localFormData.maintainer",
                                },
                              },
                              _vm._l(_vm.maintainerOptions, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label:
                                      "" +
                                      item.realName +
                                      (item.flag == 1 ? "（当前登陆人）" : ""),
                                    value: item.id,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "调价方式", prop: "isAdjust" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                on: { change: _vm.handleAdjustTypeChange },
                                model: {
                                  value: _vm.localFormData.isAdjust,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.localFormData, "isAdjust", $$v)
                                  },
                                  expression: "localFormData.isAdjust",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 0 } }, [
                                  _vm._v("不调价"),
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("按比例"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.localFormData.isAdjust === 1
                  ? _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "调价范围",
                                  prop: "adjustType",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: "请选择调价范围",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.localFormData.adjustType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.localFormData,
                                          "adjustType",
                                          $$v
                                        )
                                      },
                                      expression: "localFormData.adjustType",
                                    },
                                  },
                                  _vm._l(
                                    _vm.adjustTypeOptions,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "调价比例",
                                  prop: "adjustRate",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "请输入调价比例",
                                    type: "number",
                                    min: -1,
                                    max: 1,
                                    step: 0.01,
                                  },
                                  on: { input: _vm.handleAdjustRateInput },
                                  model: {
                                    value: _vm.localFormData.adjustRate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.localFormData,
                                        "adjustRate",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "localFormData.adjustRate",
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "adjust-tip" }, [
                                  _vm._v(
                                    "请输入-1到1之间的小数，如0.2表示20%，-0.1表示-10%"
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "联系人",
                              prop: "contactPeMerchanton",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入联系人姓名",
                                disabled: _vm.isDisabled,
                              },
                              model: {
                                value: _vm.localFormData.contactPeMerchanton,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localFormData,
                                    "contactPeMerchanton",
                                    $$v
                                  )
                                },
                                expression: "localFormData.contactPeMerchanton",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "联系电话", prop: "contactPhone" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入联系电话",
                                disabled: _vm.isDisabled,
                              },
                              model: {
                                value: _vm.localFormData.contactPhone,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localFormData,
                                    "contactPhone",
                                    $$v
                                  )
                                },
                                expression: "localFormData.contactPhone",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "微信群名称",
                              prop: "wechatGroupName",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入微信群名称" },
                              model: {
                                value: _vm.localFormData.wechatGroupName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localFormData,
                                    "wechatGroupName",
                                    $$v
                                  )
                                },
                                expression: "localFormData.wechatGroupName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "公司地址", prop: "address" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入公司地址",
                                disabled: _vm.isDisabled,
                              },
                              model: {
                                value: _vm.localFormData.address,
                                callback: function ($$v) {
                                  _vm.$set(_vm.localFormData, "address", $$v)
                                },
                                expression: "localFormData.address",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "统一社会信用代码",
                      prop: "socialCreditCode",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "请输入统一社会信用代码",
                        disabled: _vm.isDisabled,
                      },
                      model: {
                        value: _vm.localFormData.socialCreditCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.localFormData, "socialCreditCode", $$v)
                        },
                        expression: "localFormData.socialCreditCode",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "备注", prop: "remark" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 3,
                        placeholder: "请输入备注信息",
                      },
                      model: {
                        value: _vm.localFormData.remark,
                        callback: function ($$v) {
                          _vm.$set(_vm.localFormData, "remark", $$v)
                        },
                        expression: "localFormData.remark",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("h4", { staticClass: "step-title pay-config-title" }, [
                  _c("i", { staticClass: "el-icon-wallet" }),
                  _vm._v("\n        支付通道配置\n      "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pay-config-warning" }, [
                  _c("i", { staticClass: "el-icon-warning" }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "重要提示：如果切换收款商户或支付通道，可能会导致订单无法退款"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "收款商户", prop: "paymentMerchantType" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        on: { change: _vm.handlePaymentMerchantTypeChange },
                        model: {
                          value: _vm.localFormData.paymentMerchantType,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.localFormData,
                              "paymentMerchantType",
                              $$v
                            )
                          },
                          expression: "localFormData.paymentMerchantType",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: 0 } }, [
                          _vm._v("平台"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("商家"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.localFormData.paymentMerchantType === 1
                  ? [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "支付通道",
                                    prop: "payChannel",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: "请选择支付通道",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.localFormData.payChannel,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.localFormData,
                                            "payChannel",
                                            $$v
                                          )
                                        },
                                        expression: "localFormData.payChannel",
                                      },
                                    },
                                    _vm._l(
                                      _vm.payChannelOptions,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "商户号",
                                    prop: "merchantNo",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入商户号" },
                                    model: {
                                      value: _vm.localFormData.merchantNo,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.localFormData,
                                          "merchantNo",
                                          $$v
                                        )
                                      },
                                      expression: "localFormData.merchantNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "商户私钥",
                                    prop: "merchantKey",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入商户私钥",
                                      "show-password": "",
                                      autocomplete: "new-password",
                                    },
                                    model: {
                                      value: _vm.localFormData.merchantKey,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.localFormData,
                                          "merchantKey",
                                          $$v
                                        )
                                      },
                                      expression: "localFormData.merchantKey",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "商户公钥",
                                    prop: "publicMerchantKey",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入商户公钥" },
                                    model: {
                                      value:
                                        _vm.localFormData.publicMerchantKey,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.localFormData,
                                          "publicMerchantKey",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "localFormData.publicMerchantKey",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "支付通道公钥",
                                    prop: "payChannelPublicKey",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入支付通道公钥",
                                    },
                                    model: {
                                      value:
                                        _vm.localFormData.payChannelPublicKey,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.localFormData,
                                          "payChannelPublicKey",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "localFormData.payChannelPublicKey",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "证书序列号",
                                    prop: "certSerialNo",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入证书序列号" },
                                    model: {
                                      value: _vm.localFormData.certSerialNo,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.localFormData,
                                          "certSerialNo",
                                          $$v
                                        )
                                      },
                                      expression: "localFormData.certSerialNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "证书路径", prop: "certPath" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入证书路径" },
                            model: {
                              value: _vm.localFormData.certPath,
                              callback: function ($$v) {
                                _vm.$set(_vm.localFormData, "certPath", $$v)
                              },
                              expression: "localFormData.certPath",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "扩展配置" } }, [
                        _c(
                          "div",
                          { staticClass: "kv-box" },
                          [
                            _vm._l(_vm.extraList, function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "kv-row" },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "40%" },
                                    attrs: { placeholder: "配置名" },
                                    model: {
                                      value: item.key,
                                      callback: function ($$v) {
                                        _vm.$set(item, "key", $$v)
                                      },
                                      expression: "item.key",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    staticStyle: {
                                      width: "45%",
                                      "margin-left": "10px",
                                    },
                                    attrs: { placeholder: "配置值" },
                                    model: {
                                      value: item.value,
                                      callback: function ($$v) {
                                        _vm.$set(item, "value", $$v)
                                      },
                                      expression: "item.value",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-button", {
                                    staticStyle: { "margin-left": "6px" },
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-delete",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeExtra(index)
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-top": "6px" },
                                attrs: {
                                  type: "primary",
                                  size: "mini",
                                  plain: "",
                                  icon: "el-icon-plus",
                                },
                                on: { click: _vm.addExtra },
                              },
                              [_vm._v("\n              添加配置\n            ")]
                            ),
                          ],
                          2
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form-footer" }, [
      _c(
        "div",
        { staticClass: "action-buttons" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-close" },
              on: { click: _vm.handleCancel },
            },
            [_vm._v("\n        取消\n      ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                loading: _vm.submitting,
                size: "small",
                icon: "el-icon-check",
              },
              on: { click: _vm.handleSubmit },
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.isEdit ? "更新" : "保存") + "\n      "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "step-title" }, [
      _c("i", { staticClass: "el-icon-user" }),
      _vm._v("\n      基本信息\n    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }